var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-card',{attrs:{"pa-0":""}},[_c('div',[_c('quill-editor',{ref:"myTextEditor",attrs:{"options":_vm.editorOption},on:{"change":_vm.onTextWritten},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }